<template>
  <div class="manage-menu-order px-4">
    <div>Drag and Drop to Reorder</div>
    <draggable
      v-model="localSections"
      @start="drag = true"
      @end="drag = false"
      @change="sectionDragEventAction"
      v-bind="dragOptions"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <v-sheet
          outlined
          rounded
          class="section pa-2 my-3"
          v-for="section of localSections"
          :key="section.id"
        >
          <h3>{{ section.name }}</h3>
          <draggable
            v-model="section.items"
            @start="dragInner = true"
            @end="itemEndEventAction"
            @change="itemDragEventAction(section, $event)"
            v-bind="dragInnerOptions"
          >
            <transition-group
              type="transition"
              :name="!dragInner ? 'flip-list' : null"
            >
              <v-sheet
                v-for="item of section.items"
                :key="item.id"
                class="item px-2 mb-1"
                rounded
                outlined
              >
                {{ item.name }}
              </v-sheet>
            </transition-group>
          </draggable>
        </v-sheet>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import draggable from 'vuedraggable'
import { mapActions } from 'vuex'
import _sortBy from 'lodash/sortBy'

export default {
  name: 'ManageMenuOrder',
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  components: { draggable },
  data() {
    return {
      localSections: [],
      drag: false,
      dragInner: false,
      sectionRemovingItem: null,
      sectionAddingItem: null,
      rearrangeError: false,
    }
  },

  computed: {
    ...mapFields('snackbars', ['showMenuRearrangedSnackbar']),
    dragOptions() {
      return {
        animation: 200,
        group: 'sections',
        ghostClass: 'ghost',
      }
    },
    dragInnerOptions() {
      return {
        animation: 200,
        group: 'items',
        ghostClass: 'ghost',
      }
    },
  },
  methods: {
    ...mapActions('itemAndSection', ['rearrangeMenu']),
    async sectionDragEventAction(evt) {
      this.rearrangeError = false

      try {
        const updatedMenuArrangement = this.localSections.map((s, index) => {
          return { id: s.id, order: index }
        })

        if (evt.moved) {
          await this.rearrangeMenu(updatedMenuArrangement)
          this.showMenuRearrangedSnackbar = true
        }
      } catch (error) {
        this.rearrangeError = true
      }
    }, // sectionDragEventAction

    async itemDragEventAction(section, evt) {
      this.rearrangeError = false

      try {
        const updatedSectionWithItems = this.localSections.find(
          (s) => s.id === section.id
        )
        const updatedItemOrder = updatedSectionWithItems.items.map(
          (item, index) => {
            return { id: item.id, name: item.name, order: index }
          }
        )
        if (evt.moved) {
          await this.rearrangeMenu([
            { id: section.id, order: section.order, items: updatedItemOrder },
          ])
          this.showMenuRearrangedSnackbar = true
        }
        if (evt.added) {
          this.sectionAddingItem = {
            id: section.id,
            order: section.order,
            items: updatedItemOrder,
          }
        }
        if (evt.removed) {
          this.sectionRemovingItem = {
            id: section.id,
            order: section.order,
            items: updatedItemOrder,
          }
        }
      } catch (error) {
        return Promise.reject(error)
      }
    }, // itemDragEventAction
    async itemEndEventAction() {
      this.rearrangeError = false

      try {
        let sectionsToUpdate = []
        if (this.sectionAddingItem) {
          sectionsToUpdate.push(this.sectionAddingItem)
        }
        if (this.sectionRemovingItem) {
          sectionsToUpdate.push(this.sectionRemovingItem)
        }

        await this.rearrangeMenu(sectionsToUpdate)
        this.showMenuRearrangedSnackbar = true
      } catch (error) {
        this.rearrangeError = true
      } finally {
        this.sectionAddingItem = null
        this.sectionRemovingItem = null

        this.dragInner = false
      }
    }, // itemEndEventAction
    _sortBy,
  }, // methods
  watch: {
    sections: {
      handler(sections) {
        this.localSections = sections.map((s) => {
          let visibleItems = s.items.filter((item) => !item.hidden)
          return { ...s, items: _sortBy(visibleItems, 'order') }
        })
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.manage-menu-order {
  max-width: 600px;

  .item,
  .section {
    cursor: grab;
  }
  .section {
    background-color: #faf3e0;
    border-color: #fada83;
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
